import styled from 'styled-components';

export const CoursesWrapper = styled.div`
  background: #FFFCF4;
  border-radius: 12px;
  padding: 24px 24px 16px 24px;
  margin: 32px auto;
  max-width: 980px;
  width: 100%;
  box-shadow: 0 2px 12px 0 rgba(25,51,77,0.06);
`;

export const CoursesTitle = styled.h2`
  font-size: 1.25rem;
  font-weight: 600;
  color: #223046;
  margin-bottom: 18px;
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const CourseList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;
`;

export const CourseCard = styled.div<{ $dueSoon?: boolean }>`
  background: ${({ $dueSoon }) => ($dueSoon ? '#FFF6F6' : '#fff')};
  border-radius: 10px;
  box-shadow: 0 1px 4px 0 rgba(25,51,77,0.04);
  padding: 20px 24px 16px 24px;
  border: 1.5px solid #F3F4F6;
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const CourseHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const CourseCode = styled.span`
  background: #F3F4F6;
  color: #223046;
  font-size: 0.95rem;
  font-weight: 700;
  border-radius: 6px;
  padding: 2px 10px;
  letter-spacing: 1px;
`;

export const DueSoonBadge = styled.span`
  background: #B91C1C;
  color: #fff;
  font-size: 0.85rem;
  font-weight: 600;
  border-radius: 6px;
  padding: 2px 10px;
  margin-left: 6px;
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const CourseTitle = styled.h3`
  font-size: 1.15rem;
  font-weight: 700;
  color: #223046;
  margin: 0 0 2px 0;
`;

export const CourseMeta = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  font-size: 0.98rem;
  color: #6B7280;
  margin-bottom: 2px;
`;

export const CourseMetaItem = styled.span`
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const CourseDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  font-size: 0.98rem;
  color: #223046;
`;

export const NextClass = styled.div`
  color: #223046;
`;

export const Upcoming = styled.div`
  color: #223046;
`;

export const ProgressSection = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 8px;
`;

export const ProgressLabel = styled.span`
  font-size: 0.95rem;
  color: #6B7280;
  font-weight: 500;
`;

export const ProgressBar = styled.div`
  flex: 1;
  height: 7px;
  background: #F3F4F6;
  border-radius: 6px;
  overflow: hidden;
  > div {
    height: 100%;
    background: linear-gradient(90deg, #223046 60%, #7B2639 100%);
    border-radius: 6px;
    transition: width 0.3s;
  }
`;

export const ProgressPercent = styled.span`
  font-size: 0.95rem;
  color: #223046;
  font-weight: 600;
  min-width: 36px;
  text-align: right;
`;

export const ViewDetailsButton = styled.button`
  align-self: flex-end;
  margin-top: 10px;
  background: #FFFCF4;
  color: #223046;
  border: 1.5px solid #F3F4F6;
  border-radius: 8px;
  padding: 6px 18px;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.15s, border 0.15s;
  &:hover, &:focus {
    background: #F3F4F6;
    border: 1.5px solid #7B2639;
    outline: none;
  }
`;
